export const siteMeta = {
  churchName: "Reformed Missional Church",
  tagline: "Christ-Centered. Gospel-Driven. Missionally Living.",
  mission:
    "We exist to glorify God by proclaiming Jesus Christ, making mature disciples, building a gospel-centered church, and living faithfully on God's mission.",
  location: "Chennai, Tamil Nadu",
  address:
    "Reformed Missional Church, Perumbakkam Main Rd, Medavakkam, Chennai-600100, Tamil Nadu",
  coordinates: "12.916954059029988,80.19778186480804",
  serviceTime: "Sunday Worship - 10:00 AM",
  phone: "+91 97104 20966",
  email: "reformedmissionalchurch@gmail.com",
  youtube: "https://www.youtube.com/@reformedmissionalchurch",
  communityApp: "https://rmccommunity.netlify.app/home",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d43996.43512406861!2d80.14011954643185!3d12.922357430663407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525ee22103a507%3A0xe4ae266d103bf140!2sZIMEDCODE-%20Medical%20Coding%20Training%20in%20Chennai!5e0!3m2!1sen!2sin!4v1783565256263!5m2!1sen!2sin",
  directionsUrl: "https://maps.app.goo.gl/HyrGWjkC6gGDXncz9",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Beliefs", path: "/beliefs" },
  { label: "Gospel", path: "/gospel" },
  { label: "Sermons", path: "/sermons" },
  { label: "Ministries", path: "/ministries" },
  { label: "Resources", path: "/resources" },
  { label: "Solid Joy", path: "/blog" },
  { label: "Visit Us", path: "/visit" },
];

export const languageLabels = {
  en: {
    visit: "Plan Your Visit",
    gospel: "What Is the Gospel?",
    contact: "Contact",
  },
  ta: {
    visit: "வருகையை திட்டமிடுங்கள்",
    gospel: "சுவிசேஷம் என்ன?",
    contact: "தொடர்பு கொள்ளுங்கள்",
  },
};

export const homeContent = {
  hero: {
    title: "Christ-Centered.\nGospel-Driven.\nMissionally Living.",
    text: "Reformed Missional Church exists to glorify God by proclaiming the gospel of Jesus Christ, making mature disciples, building a Christ-centered community, and living faithfully on God's mission in the world.",
  },
  welcome: {
    label: "Welcome to Reformed Missional Church",
    title: "A Church Centered on Christ and His Gospel",
    text: [
      "We are a community of believers gathered by the grace of God, under the authority of His Word, for the glory of His name.",
      "We believe the church is not merely a place we attend, but a people redeemed by Jesus Christ, shaped by the gospel, growing together in holiness, and sent into the world to make disciples.",
      "Whether you are exploring Christianity, searching for a church, or seeking to grow deeper in your faith, we invite you to know Christ with us.",
    ],
  },
};

export const identityCards = [
  {
    label: "Reformed",
    heading: "Rooted in God's Sovereign Grace",
    text: "We believe salvation is entirely the work of God's grace, from beginning to end. Our faith is rooted in the historic truths recovered during the Reformation and summarized by the five solas: Scripture alone, grace alone, faith alone, Christ alone, and to the glory of God alone.",
  },
  {
    label: "Missional",
    heading: "Sent with the Gospel",
    text: "The church does not exist only for itself. Every believer is called to live as a witness of Jesus Christ in the home, workplace, neighbourhood, city, and world.",
  },
  {
    label: "Church",
    heading: "A Covenant Community",
    text: "We are not merely an audience attending a weekly program. We are a family of believers committed to worship, discipleship, fellowship, prayer, service, accountability, and mission.",
  },
  {
    label: "Christ-Centered",
    heading: "Christ Above All",
    text: "Jesus Christ is not one part of our church. He is the centre of everything. We preach Christ, worship Christ, follow Christ, and seek to make Christ known.",
  },
];

export const gospelSteps = [
  {
    number: "01",
    title: "Our Creator and King",
    label: "God",
    text: "God created us for His glory. He is holy, righteous, loving, and worthy of our complete worship and obedience.",
  },
  {
    number: "02",
    title: "Guilty Before God",
    label: "Man",
    text: "Humanity has rebelled against God. Sin is not merely making mistakes; it is rejecting God's rightful rule. Because God is holy and just, sin deserves judgment.",
  },
  {
    number: "03",
    title: "The Only Saviour",
    label: "Christ",
    text: "God sent His eternal Son, Jesus Christ. He lived the perfect life we failed to live, died on the cross bearing the judgment sinners deserve, and rose bodily from the dead.",
  },
  {
    number: "04",
    title: "Repent and Believe",
    label: "Response",
    text: "The gospel calls every person to turn from sin and trust in Jesus Christ alone. Salvation is not earned by good works, religion, baptism, or human effort. It is received by grace alone through faith alone in Christ alone.",
  },
];

export const sermons = [
  {
    id: "fSLyBez5v9g",
    title: "Acts 1:12-26",
    passage: "Acts 1:12-26",
    preacher: "Bro. Eliyaser",
    date: "July 5, 2026",
    year: "2026",
    book: "Acts",
    topic: "Expository Preaching",
    series: "Acts",
    speaker: "Bro. Eliyaser",
    description:
      "The latest sermon calling the church to see how the Scripture was fulfilled and how the risen Christ gathers His people by His Word.",
    thumbnail: "https://i.ytimg.com/vi/fSLyBez5v9g/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=fSLyBez5v9g",
    audioUrl: "https://www.youtube.com/watch?v=fSLyBez5v9g",
    notes:
      "This message traces the disciples' obedience, the sufficiency of Scripture, and the Lord's providential care for His church.",
  },
  {
    id: "LT0hP8O6hts",
    title: "Christian Prayer Life",
    passage: "Psalm 132",
    preacher: "Bro. Fredrick",
    date: "June 28, 2026",
    year: "2026",
    book: "Psalms",
    topic: "Prayer",
    series: "Psalms",
    speaker: "Bro. Fredrick",
    description:
      "A sermon on the place of prayer, dependence, and perseverance in the Christian life.",
    thumbnail: "https://i.ytimg.com/vi/LT0hP8O6hts/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=LT0hP8O6hts",
    audioUrl: "https://www.youtube.com/watch?v=LT0hP8O6hts",
    notes:
      "The message urges the church to cultivate prayerful hearts shaped by God's covenant faithfulness.",
  },
  {
    id: "HkxScuVUAnA",
    title: "Colossians 1:11",
    passage: "Colossians 1:11",
    preacher: "Bro. Imayavaramban",
    date: "June 21, 2026",
    year: "2026",
    book: "Colossians",
    topic: "Christian Living",
    series: "Colossians",
    speaker: "Bro. Imayavaramban",
    description:
      "A call to endurance, patience, and joy through the strength the Lord supplies.",
    thumbnail: "https://i.ytimg.com/vi/HkxScuVUAnA/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=HkxScuVUAnA",
    audioUrl: "https://www.youtube.com/watch?v=HkxScuVUAnA",
    notes:
      "This sermon presses the church toward steadfast holiness rooted in the grace of Christ.",
  },
  {
    id: "bJ5vGnFVcig",
    title: "Acts 1:9-11",
    passage: "Acts 1:9-11",
    preacher: "Bro. Eliyaser",
    date: "June 14, 2026",
    year: "2026",
    book: "Acts",
    topic: "Mission",
    series: "Acts",
    speaker: "Bro. Eliyaser",
    description:
      "An exposition of Christ's ascension and the church's witness until He comes again.",
    thumbnail: "https://i.ytimg.com/vi/bJ5vGnFVcig/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=bJ5vGnFVcig",
    audioUrl: "https://www.youtube.com/watch?v=bJ5vGnFVcig",
    notes:
      "The message fixes our eyes on the exalted Christ and the urgency of gospel witness.",
  },
  {
    id: "GjLMQLifqhY",
    title: "Romans 8:9-11",
    passage: "Romans 8:9-11",
    preacher: "Bro. Isaac Jeyakumar",
    date: "June 24, 2026",
    year: "2026",
    book: "Romans",
    topic: "Doctrine",
    series: "Romans",
    speaker: "Bro. Isaac Jeyakumar",
    description: "A Bible study on the indwelling Spirit and life in Christ.",
    thumbnail: "https://i.ytimg.com/vi/GjLMQLifqhY/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=GjLMQLifqhY",
    audioUrl: "https://www.youtube.com/watch?v=GjLMQLifqhY",
    notes:
      "This study clarifies union with Christ, spiritual life, and the believer's hope.",
  },
  {
    id: "ewBmOF52Aw0",
    title: "Expositional Study from Romans",
    passage: "Romans 8",
    preacher: "Bro. Isaac Jeyakumar",
    date: "June 10, 2026",
    year: "2026",
    book: "Romans",
    topic: "Expository Preaching",
    series: "Romans",
    speaker: "Bro. Isaac Jeyakumar",
    description:
      "A careful exposition from the Epistle to the Romans in the Reformation Bible Study.",
    thumbnail: "https://i.ytimg.com/vi/ewBmOF52Aw0/hqdefault.jpg",
    videoUrl: "https://www.youtube.com/watch?v=ewBmOF52Aw0",
    audioUrl: "https://www.youtube.com/watch?v=ewBmOF52Aw0",
    notes:
      "A rich study emphasizing justification, life in the Spirit, and gospel assurance.",
  },
];

export const lifeTogetherCards = [
  {
    title: "Worship Together",
    text: "We gather as the people of God to hear His Word, pray, sing, remember the gospel, and encourage one another.",
  },
  {
    title: "Grow Together",
    text: "We grow through Scripture, discipleship, prayer, fellowship, and mutual encouragement.",
  },
  {
    title: "Serve One Another",
    text: "Every believer has been gifted by God to serve and build up the body of Christ.",
  },
  {
    title: "Live on Mission",
    text: "We seek to proclaim and display the gospel wherever God has placed us.",
  },
];

export const solas = [
  { latin: "Sola Scriptura", english: "Scripture Alone" },
  { latin: "Sola Gratia", english: "Grace Alone" },
  { latin: "Sola Fide", english: "Faith Alone" },
  { latin: "Solus Christus", english: "Christ Alone" },
  { latin: "Soli Deo Gloria", english: "To the Glory of God Alone" },
];

export const visitHighlights = [
  "Biblical expository preaching",
  "Christ-centered worship",
  "Prayer",
  "Christian fellowship",
  "A welcoming community",
];

export const visitDetails = [
  { label: "Sunday worship time", value: "10:00 AM" },
  { label: "Location", value: "Chennai, Tamil Nadu" },
  { label: "Parking", value: "Street and nearby parking available" },
  { label: "Service duration", value: "Around 90 minutes" },
  { label: "Children", value: "Families and children are welcome" },
  { label: "Language", value: "English and Tamil ministry contexts" },
];

export const aboutSections = [
  {
    title: "Our Story",
    text: "Reformed Missional Church exists because we believe Christ is building His church through the faithful ministry of the Word, prayer, and the gospel. We desire to be a congregation marked by truth, reverence, warmth, and everyday faithfulness.",
  },
  {
    title: "Why We Exist",
    text: "We exist to glorify God by proclaiming Jesus Christ, making mature disciples, and building a church community shaped by grace and sent with the gospel.",
  },
  {
    title: "Why Reformed",
    text: "We gladly stand in the stream of historic Reformed Christianity, confessing the authority and sufficiency of Scripture, the sovereignty of God in salvation, and the centrality of Christ in all of life.",
  },
  {
    title: "Why Missional",
    text: "We believe the church is sent into the world as Christ's witness. Mission is not a department of the church; it is part of the church's very life and calling.",
  },
  {
    title: "Why Church",
    text: "The church is not a crowd gathered around a personality or event. It is a covenant community that worships, learns, repents, serves, and bears witness together under the lordship of Christ.",
  },
  {
    title: "Our Mission",
    text: siteMeta.mission,
  },
  {
    title: "Our Vision",
    text: "To see people rooted in the Word, centered on Christ, growing in holiness, and living faithfully for the glory of God in every sphere of life.",
  },
  {
    title: "Our Values",
    text: "Scripture, prayer, worship, discipleship, holiness, hospitality, theological depth, and mission are not competing values for us; they belong together in healthy church life.",
  },
  {
    title: "Church Leadership",
    text: "We desire leadership that is servant-hearted, biblically grounded, accountable, and devoted to the care of souls through teaching, prayer, and example.",
  },
];

export const beliefSections = [
  {
    title: "The Holy Scriptures",
    text: "We believe the Bible is the inspired, inerrant, sufficient, and final authority for faith and life.",
  },
  {
    title: "The Triune God",
    text: "There is one true and living God, eternally existing as Father, Son, and Holy Spirit.",
  },
  {
    title: "God the Father",
    text: "The Father rules over all things in wisdom, holiness, justice, and love.",
  },
  {
    title: "Jesus Christ",
    text: "Jesus Christ is fully God and fully man, the only Mediator between God and man.",
  },
  {
    title: "The Holy Spirit",
    text: "The Holy Spirit applies the redemption of Christ, giving new life and sanctifying believers.",
  },
  {
    title: "Creation and Providence",
    text: "God created all things and upholds, governs, and directs all things according to His wise will.",
  },
  {
    title: "Humanity and Sin",
    text: "Human beings were created in God's image but fell into sin and stand guilty before Him.",
  },
  {
    title: "Election and Grace",
    text: "Salvation rests in the sovereign grace of God, who chose a people in Christ before the foundation of the world.",
  },
  {
    title: "The Person and Work of Christ",
    text: "Christ obeyed, suffered, died, rose, and reigns for the salvation of His people.",
  },
  {
    title: "The Atonement",
    text: "In His death Christ bore the judgment of sinners and accomplished full redemption.",
  },
  {
    title: "Regeneration and Conversion",
    text: "God gives new birth by the Spirit, enabling sinners to repent and believe the gospel.",
  },
  {
    title: "Justification by Faith Alone",
    text: "God declares sinners righteous on the basis of Christ's righteousness, received by faith alone.",
  },
  {
    title: "Adoption",
    text: "All who are united to Christ are received as sons and daughters of God.",
  },
  {
    title: "Sanctification",
    text: "Believers are progressively conformed to the image of Christ by the Spirit and the Word.",
  },
  {
    title: "Perseverance of the Saints",
    text: "Those whom God saves He keeps by His grace to the end.",
  },
  {
    title: "The Church",
    text: "The church is the redeemed people of God, gathered for worship, fellowship, discipline, and mission.",
  },
  {
    title: "Baptism and the Lord's Supper",
    text: "The ordinances visibly proclaim the gospel and strengthen the faith of the church.",
  },
  {
    title: "The Mission of the Church",
    text: "The church is called to make disciples through gospel proclamation, baptism, and teaching.",
  },
  {
    title: "The Return of Christ",
    text: "Jesus Christ will personally and gloriously return to judge the living and the dead.",
  },
  {
    title: "Resurrection and Final Judgment",
    text: "All people will be raised, and God will judge every person in righteousness.",
  },
  {
    title: "The New Heavens and New Earth",
    text: "God will make all things new, and His people will dwell with Him forever.",
  },
];

export const gospelPageSections = [
  {
    title: "God Is the Holy Creator",
    text: "God made the world and everything in it. He is holy, righteous, loving, and worthy of all glory, worship, and obedience.",
  },
  {
    title: "We Have Sinned Against God",
    text: "Every one of us has rebelled against God's rule. Sin is not merely failure; it is cosmic treason against our Creator and King.",
  },
  {
    title: "We Cannot Save Ourselves",
    text: "No moral effort, religion, or self-improvement can reconcile us to God. Left to ourselves, we remain guilty and helpless.",
  },
  {
    title: "Jesus Christ Is the Saviour",
    text: "God sent His eternal Son into the world. Jesus lived the righteous life we failed to live and perfectly obeyed the Father.",
  },
  {
    title: "Christ Died for Sinners",
    text: "At the cross Jesus bore the judgment our sins deserve, laying down His life in the place of guilty sinners.",
  },
  {
    title: "Christ Rose from the Dead",
    text: "Jesus rose bodily from the grave, defeating death and proving that His saving work was fully accepted by the Father.",
  },
  {
    title: "Repent and Believe",
    text: "The gospel calls you to turn from sin and trust in Christ alone. Salvation is received by grace alone through faith alone.",
  },
  {
    title: "Count the Cost and Follow Christ",
    text: "Jesus calls His people not merely to admire Him, but to follow Him as Lord in a life of repentance, faith, worship, and obedience.",
  },
];

export const ministryGroups = [
  {
    title: "Sunday Gathering",
    text: "The church gathers to worship, hear the Word preached, pray, and encourage one another in the gospel.",
  },
  {
    title: "Bible Study",
    text: "We study the Scriptures together so that doctrine shapes worship, discipleship, and daily Christian life.",
  },
  {
    title: "Discipleship",
    text: "We want believers to grow into maturity through teaching, prayer, accountability, and personal encouragement.",
  },
  {
    title: "Prayer",
    text: "Prayer is not peripheral to church life. We seek to depend upon God in gathered prayer and in personal intercession.",
  },
  {
    title: "Men",
    text: "Men are called to grow in holiness, leadership, humility, and faithfulness in home, church, and witness.",
  },
  {
    title: "Women",
    text: "Women are encouraged to grow deeply in Christ, serve the church, and build one another up in grace and truth.",
  },
  {
    title: "Children",
    text: "We want our children to know the Scriptures, love Christ, and understand the gospel from an early age.",
  },
  {
    title: "Mission and Evangelism",
    text: "The church is called to speak the gospel clearly and to live lives that commend the grace of Christ to the world.",
  },
];

export const resourceItems = [
  {
    title: "Why the Gospel Must Stay Central",
    category: "Doctrine",
    language: "English",
    excerpt:
      "A short article on why the person and work of Christ must remain central in preaching, worship, and discipleship.",
  },
  {
    title: "Family Worship in Ordinary Life",
    category: "Marriage and Family",
    language: "English",
    excerpt:
      "Simple encouragement for families who want to build regular habits of Scripture, prayer, and worship at home.",
  },
  {
    title: "The Church and Her Mission",
    category: "Mission",
    language: "English",
    excerpt:
      "A biblical reflection on the church's responsibility to proclaim Christ and make disciples.",
  },
  {
    title: "சுவிசேஷம் என்றால் என்ன?",
    category: "Tamil Resources",
    language: "Tamil",
    excerpt: "சுவிசேஷத்தின் மைய உண்மைகள் குறித்து தெளிவான அறிமுகம்.",
  },
  {
    title: "Growing Through the Psalms",
    category: "Bible Studies",
    language: "English",
    excerpt:
      "Selected study helps for prayer, lament, and worship from the Psalms.",
  },
  {
    title: "Grace Alone Notes",
    category: "Articles",
    language: "English",
    excerpt:
      "Brief notes on the beauty of sovereign grace and the comfort it brings to weary sinners.",
  },
];

export const visitFaqs = [
  {
    question: "When do you meet?",
    answer: "We gather every Sunday for worship and preaching at 10:00 AM.",
  },
  {
    question: "Where are you located?",
    answer: "We are located in Chennai, Tamil Nadu.",
  },
  {
    question: "What happens during the service?",
    answer:
      "You can expect Scripture reading, prayer, Christ-centered worship, expository preaching, and fellowship.",
  },
  {
    question: "How long is the service?",
    answer: "Our Sunday gathering typically lasts around 90 minutes.",
  },
  {
    question: "What should I wear?",
    answer:
      "Come in modest and comfortable clothing. There is no dress code beyond reverence and simplicity.",
  },
  {
    question: "Can I come if I am not a Christian?",
    answer:
      "Yes. You are welcome to come, listen, and ask questions. We would be glad to meet you.",
  },
  {
    question: "What about children?",
    answer:
      "Children are welcome. Families are encouraged to worship together, and we seek to serve them with care.",
  },
  {
    question: "Parking and directions",
    answer:
      "Parking is available nearby, and directions can be accessed through the map section.",
  },
];
